<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 382 146"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g :fill="fill"
      stroke="none" transform="translate(0.000000,146.000000) scale(0.100000,-0.100000)"
    >
      <path d="M584 1426 c-17 -8 -38 -23 -45 -34 -12 -17 -29 -20 -127 -24 -83 -3
-116 -8 -123 -19 -16 -25 -10 -33 11 -14 19 17 27 17 96 7 124 -19 214 -70
226 -127 4 -18 6 -18 15 5 26 61 109 104 234 123 76 11 82 10 95 -8 15 -21 19
-9 4 15 -7 11 -36 15 -117 18 -102 4 -110 5 -138 32 -37 35 -89 45 -131 26z
m80 -45 c33 -37 3 -80 -47 -67 -21 5 -27 12 -27 34 0 51 42 69 74 33z"
      />
      <path d="M1421 1318 l-51 -52 0 -416 0 -416 53 -52 53 -52 215 0 215 0 52 53
53 53 -3 120 -3 119 -87 3 -88 3 0 -91 0 -90 -135 0 -135 0 0 355 0 356 133
-3 132 -3 3 -87 3 -88 89 0 90 0 0 120 0 121 -46 49 -47 50 -222 0 -223 0 -51
-52z"
      />
      <path d="M2177 1318 l-47 -52 0 -191 0 -191 53 -52 53 -52 172 0 172 0 0 -140
0 -140 -135 0 -135 0 0 70 0 70 -90 0 -90 0 0 -103 0 -103 53 -52 53 -52 215
0 215 0 52 53 52 53 0 201 0 202 -51 50 -52 51 -166 0 c-91 0 -172 4 -179 8
-9 7 -12 40 -10 133 l3 124 132 3 132 3 3 -73 3 -73 90 0 90 0 3 101 3 102
-50 51 -50 51 -223 0 -224 0 -47 -52z"
      />
      <path d="M2936 1320 l-46 -49 0 -420 0 -420 51 -50 52 -51 216 0 217 0 52 53
52 53 0 242 0 242 -170 0 -170 0 0 -80 0 -80 75 0 75 0 0 -130 0 -130 -135 0
-135 0 2 353 3 352 133 3 132 3 0 -76 0 -75 95 0 95 0 0 103 0 103 -53 52 -53
52 -220 0 -221 0 -47 -50z"
      />
      <path d="M3595 1347 c-41 -34 -39 -90 3 -128 36 -32 60 -36 101 -14 33 17 41
33 41 85 0 72 -88 107 -145 57z m110 -12 c50 -49 20 -125 -49 -125 -40 0 -76
37 -76 77 0 32 42 73 75 73 14 0 37 -11 50 -25z"
      />
      <path d="M3627 1333 c-11 -10 -8 -93 3 -93 6 0 10 7 10 15 0 21 10 19 38 -7
l25 -23 -12 22 c-9 17 -9 27 1 42 9 15 9 23 -1 35 -14 16 -52 22 -64 9z m51
-26 c2 -12 -3 -17 -17 -17 -15 0 -21 6 -21 21 0 25 33 22 38 -4z"
      />
      <path d="M315 1300 c15 -56 149 -482 181 -576 19 -55 34 -104 34 -107 0 -4
-103 -7 -230 -7 -195 0 -230 2 -230 15 0 13 33 118 161 513 27 84 49 159 49
165 -1 12 -65 -150 -128 -323 -17 -47 -56 -154 -87 -237 -52 -144 -55 -154
-41 -180 28 -54 84 -108 141 -137 139 -70 311 -17 391 120 l25 43 -40 113
c-22 62 -67 187 -101 278 -34 91 -75 203 -91 249 -27 79 -50 126 -34 71z"
      />
      <path d="M981 1303 c-1 -6 12 -49 28 -95 16 -46 64 -193 106 -328 43 -135 80
-251 82 -257 4 -10 -46 -13 -231 -13 -130 0 -236 2 -236 4 0 3 11 35 24 73 14
37 50 149 81 248 31 99 70 220 87 268 16 49 28 90 25 93 -5 5 -26 -46 -86
-211 -22 -60 -72 -195 -111 -300 l-70 -189 20 -41 c25 -52 71 -96 138 -130
136 -70 319 -11 391 127 l23 43 -32 85 c-18 47 -49 132 -70 190 -150 411 -168
456 -169 433z"
      />
      <path d="M617 868 c-4 -134 -11 -286 -17 -338 -9 -84 -14 -98 -39 -123 -15
-16 -57 -39 -92 -52 l-64 -24 225 0 c135 0 217 4 205 9 -11 5 -42 16 -68 26
-66 23 -93 58 -101 131 -12 115 -26 350 -26 468 -1 218 -17 151 -23 -97z"
      />
      <path d="M43 185 c-41 -29 -42 -116 -3 -155 26 -26 100 -28 100 -4 0 12 -6 15
-25 10 -17 -4 -31 0 -45 14 -44 44 -10 140 46 126 17 -5 24 -2 24 9 0 20 -68
20 -97 0z"
      />
      <path d="M180 105 l0 -95 50 0 c38 0 50 4 50 15 0 10 -11 15 -35 15 -30 0 -35
3 -35 24 0 20 6 25 32 28 43 4 48 26 6 30 -25 2 -34 8 -36 25 -3 18 2 22 29
25 56 5 48 28 -10 28 l-51 0 0 -95z"
      />
      <path d="M320 105 c0 -78 3 -95 15 -95 11 0 15 11 15 41 0 32 3 40 17 37 9 -2
22 -19 28 -38 6 -19 19 -36 28 -38 21 -4 22 17 3 63 -13 29 -13 35 0 46 39 32
2 79 -62 79 l-44 0 0 -95z m68 66 c19 -11 11 -45 -11 -49 -19 -4 -32 20 -23
43 6 17 15 19 34 6z"
      />
      <path d="M460 190 c0 -6 11 -15 25 -20 24 -9 25 -14 25 -85 0 -60 3 -75 15
-75 12 0 15 15 15 79 0 70 2 79 20 84 43 11 19 27 -40 27 -34 0 -60 -4 -60
-10z"
      />
      <path d="M610 105 c0 -88 1 -95 20 -95 19 0 20 7 20 95 0 88 -1 95 -20 95 -19
0 -20 -7 -20 -95z"
      />
      <path d="M680 105 c0 -88 1 -95 20 -95 17 0 20 7 20 40 0 38 2 40 30 40 20 0
30 5 30 15 0 10 -10 15 -30 15 -25 0 -30 4 -30 24 0 19 6 25 27 28 14 2 28 9
31 16 2 8 -11 12 -47 12 l-51 0 0 -95z"
      />
      <path d="M810 105 c0 -88 1 -95 20 -95 19 0 20 7 20 95 0 88 -1 95 -20 95 -19
0 -20 -7 -20 -95z"
      />
      <path d="M880 105 l0 -95 56 0 c40 0 55 4 52 13 -3 6 -19 13 -36 15 -26 3 -32
8 -32 28 0 20 5 24 30 24 39 0 41 27 3 32 -20 2 -29 9 -31 25 -3 18 2 22 29
25 18 2 34 9 37 16 3 8 -12 12 -52 12 l-56 0 0 -95z"
      />
      <path d="M1030 105 l0 -95 41 0 c54 0 75 13 89 56 10 28 10 46 1 75 -14 45
-35 59 -90 59 l-41 0 0 -95z m88 47 c29 -38 8 -98 -40 -115 -16 -6 -18 2 -18
69 0 73 1 75 23 69 12 -4 28 -14 35 -23z"
      />
      <path d="M1272 188 c-27 -27 -9 -73 39 -99 13 -6 19 -18 17 -32 -2 -18 -9 -22
-36 -19 -23 1 -32 -2 -32 -13 0 -24 86 -21 100 4 18 35 11 58 -27 88 -26 22
-34 35 -30 48 5 12 14 15 32 11 18 -5 25 -2 25 9 0 19 -70 21 -88 3z"
      />
      <path d="M1400 105 c0 -88 1 -95 20 -95 16 0 20 7 20 35 0 32 3 36 30 42 32 6
50 28 50 62 0 32 -27 51 -76 51 l-44 0 0 -95z m68 66 c19 -12 11 -55 -10 -59
-15 -3 -18 4 -18 32 0 37 5 42 28 27z"
      />
      <path d="M1563 173 c-10 -15 -18 -46 -18 -68 0 -62 26 -95 75 -95 51 0 75 33
74 102 -1 62 -23 88 -75 88 -31 0 -42 -5 -56 -27z m81 -9 c24 -24 21 -96 -5
-120 -21 -19 -21 -18 -41 6 -16 19 -19 35 -15 69 6 57 31 75 61 45z"
      />
      <path d="M1720 105 c0 -88 1 -95 20 -95 17 0 20 7 20 40 0 22 5 40 11 40 6 0
18 -18 26 -40 11 -27 22 -40 35 -40 21 0 19 18 -7 70 -11 21 -10 27 1 38 17
16 18 54 2 70 -7 7 -34 12 -60 12 l-48 0 0 -95z m68 66 c19 -11 11 -45 -11
-49 -13 -3 -17 3 -17 27 0 32 6 37 28 22z"
      />
      <path d="M1860 190 c0 -5 11 -12 25 -16 24 -6 25 -9 25 -85 0 -64 3 -79 15
-79 12 0 15 15 15 75 0 71 1 76 25 85 45 17 27 30 -40 30 -36 0 -65 -4 -65
-10z"
      />
      <path d="M2022 188 c-26 -26 -11 -73 29 -94 49 -25 32 -71 -20 -57 -15 4 -21
1 -21 -11 0 -12 10 -16 43 -16 50 0 67 13 67 51 0 19 -11 36 -37 56 -26 22
-34 35 -30 48 5 12 14 15 32 11 18 -5 25 -2 25 9 0 19 -70 21 -88 3z"
      />
      <path d="M2248 190 c-22 -14 -41 -74 -33 -109 11 -50 40 -71 96 -71 l50 0 -3
53 c-3 48 -5 52 -30 55 -30 4 -40 -21 -13 -32 20 -7 19 -45 -2 -53 -21 -8 -63
39 -63 71 0 13 10 36 21 51 19 23 27 26 55 20 27 -5 34 -3 34 10 0 11 -11 15
-47 15 -27 0 -56 -5 -65 -10z"
      />
      <path d="M2400 117 c0 -95 7 -107 61 -107 54 0 69 26 69 117 0 66 -2 73 -20
73 -18 0 -20 -7 -20 -74 0 -55 -4 -77 -16 -87 -27 -22 -44 14 -44 93 0 54 -3
68 -15 68 -12 0 -15 -16 -15 -83z"
      />
      <path d="M2577 112 c-15 -49 -27 -92 -27 -95 0 -16 29 -5 35 13 9 28 71 28 80
0 4 -11 15 -20 27 -20 12 0 18 5 16 13 -3 6 -17 49 -32 95 -24 70 -31 82 -50
82 -20 0 -26 -11 -49 -88z m63 26 c0 -7 3 -23 6 -35 5 -18 2 -23 -13 -23 -28
0 -33 8 -21 41 10 29 28 40 28 17z"
      />
      <path d="M2730 105 c0 -88 1 -95 20 -95 17 0 20 7 20 40 0 28 4 40 15 40 8 0
19 -17 26 -40 9 -29 18 -40 31 -40 21 0 19 18 -7 72 -11 22 -10 28 1 32 17 7
18 58 2 74 -7 7 -34 12 -60 12 l-48 0 0 -95z m90 50 c0 -17 -16 -35 -31 -35
-13 0 -19 7 -19 23 0 13 3 27 6 30 6 6 44 -9 44 -18z"
      />
      <path d="M2919 128 c-11 -40 -25 -83 -30 -95 -7 -19 -5 -23 10 -23 10 0 21 9
24 20 7 29 72 29 80 0 3 -11 12 -20 21 -20 20 0 21 -5 -11 101 -23 78 -29 89
-49 89 -20 0 -26 -10 -45 -72z m60 -8 c8 -25 7 -32 -5 -37 -22 -8 -33 8 -27
40 7 35 18 34 32 -3z"
      />
      <path d="M3070 105 c0 -78 3 -95 15 -95 12 0 15 14 16 68 l0 67 31 -67 c22
-49 36 -68 49 -68 17 0 19 9 19 95 0 78 -3 95 -15 95 -12 0 -15 -14 -16 -62
l-1 -63 -30 63 c-21 44 -35 62 -49 62 -17 0 -19 -8 -19 -95z"
      />
      <path d="M3230 190 c0 -6 11 -15 25 -20 24 -9 25 -14 25 -85 0 -60 3 -75 15
-75 12 0 15 15 15 79 0 76 1 79 25 85 47 12 25 26 -40 26 -38 0 -65 -4 -65
-10z"
      />
      <path d="M3387 183 c4 -10 17 -36 30 -58 12 -22 23 -57 23 -77 0 -27 4 -38 15
-38 11 0 15 11 15 41 0 28 10 59 31 95 l30 54 -24 0 c-20 0 -28 -7 -38 -37
l-12 -37 -19 37 c-12 24 -26 37 -38 37 -14 0 -18 -5 -13 -17z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Csg',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
